module.exports = __webpack_public_path__ + "assets/Theta.7dafb02414e7741aaff404ff8e29033e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Theta.png
// module id = 800
// module chunks = 0